import { TestConfig } from 'yup';

import { validateFullName } from 'lib/utils/validation/validateFullName';

/**
 * Check if as a valid full name
 */
export const fullNameTest = (): TestConfig<string | undefined> => ({
  name: 'fullName',
  exclusive: false,
  message: 'Digite um nome e sobrenome.',
  test: validateFullName,
});
